
const BREAKPOINT = {
  '--sm-viewport': '(min-width:0)',
  '--md-viewport': '(min-width:680px)',
  '--mdh-viewport': '(min-width:960px)',
  '--lg-viewport': '(min-width:1200px)',
  '--xl-viewport': '(min-width:1440px)',
  '--portrait': '(orientation: portrait)',
  '--landscape': '(orientation: landscape)',
};

const BREAKPOINT_NEWDESIGN = {
  '--sm-viewport': '(min-width:0)',
  '--md-viewport': '(min-width:768px)',
  '--mdh-viewport': '(min-width:1024px)',
  '--lg-viewport': '(min-width:1280px)',
  '--portrait': '(orientation: portrait)',
  '--landscape': '(orientation: landscape)',
};

const _getBreakpoint = () => {
  if (window.matchMedia(BREAKPOINT['--lg-viewport']).matches) {
    return 'large';
  } else if (window.matchMedia(BREAKPOINT['--mdh-viewport']).matches) {
    return 'medium-high';
  } else if (window.matchMedia(BREAKPOINT['--md-viewport']).matches) {
    return 'medium';
  } else if (window.matchMedia(BREAKPOINT['--sm-viewport']).matches) {
    return 'small';
  }
};

const _getBreakpointNewDesign = () => {
  if (window.matchMedia(BREAKPOINT_NEWDESIGN['--lg-viewport']).matches) {
    return 'large';
  } else if (window.matchMedia(BREAKPOINT_NEWDESIGN['--mdh-viewport']).matches) {
    return 'medium-high';
  } else if (window.matchMedia(BREAKPOINT_NEWDESIGN['--md-viewport']).matches) {
    return 'medium';
  } else if (window.matchMedia(BREAKPOINT_NEWDESIGN['--sm-viewport']).matches) {
    return 'small';
  }
};

const _getOrientation = () => {
  if (window.matchMedia(BREAKPOINT['--landscape']).matches) {
    return 'landscape';
  } else if (window.matchMedia(BREAKPOINT['--portrait']).matches) {
    return 'portrait';
  }
};

const printMedia = window.matchMedia('print');
const _getIsPrint = () => {
  return printMedia.matches;
};

/**
 * subs is an object of components subscribed to breakpoint mixin
 */
const subs = {};

const _window = {
  breakpoint: _getBreakpoint(),
  brekpointNewDesign: _getBreakpointNewDesign(),
  dimensions: {
    x: window.innerWidth,
    y: window.innerHeight,
  },
  isPrint: _getIsPrint(),
};

let _ticking = false;
let inst = null;

export default function() {
  // singleton resize manager class
  inst = inst || (new class ResizeManager {
    // Add Event Listeners to window if not already present
    addBreakpointListeners() {
      window.addEventListener('resize', this._requestTick);
      printMedia.addListener(this.setIsPrint);
    }

    removeBreakpointListeners() {
      window.removeEventListener('resize', this._requestTick);
      printMedia.removeListener(this.setIsPrint);
    }

    setBreakpoint() {
      _window.breakpoint = _getBreakpoint();
      _window.breakpointNewDesign = _getBreakpointNewDesign();
    }

    getCurrentBreakpoint() {
      return _getBreakpoint();
    }

    getCurrentBreakpointNewDesign() {
      return _getBreakpointNewDesign();
    }

    setOrientation() {
      _window.orientation = _getOrientation();
    }

    getCurrentOrientation() {
      return _getOrientation();
    }

    setDimensions() {
      _window.dimensions = {
        x: window.innerWidth,
        y: window.innerHeight,
      };
    }

    getCurrentDimensions() {
      return _window.dimensions;
    }

    setIsPrint = ({ matches }) => {
      _window.isPrint = matches;
      this.publish(_window);
    }

    getIsPrint() {
      return _window.isPrint;
    }

    publish(breakpoint, orientation, dimensions) {
      for (const key in subs) {
        if (subs.hasOwnProperty(key)) {
          subs[key](breakpoint, orientation, dimensions);
        }
      }
    }

    subscribe(key, fn) {
      subs[key] = fn;
    }

    unsubscribe(key) {
      delete subs[key];
    }

    _requestTick = () => {
      if (!_ticking) {
        requestAnimationFrame(this._onResize);
        _ticking = true;
      }
    }

    _onResize = () => {
      this.setDimensions();
      this.setBreakpoint();
      this.setOrientation();
      this.publish(_window);

      _ticking = false;
    }
  });

  return inst;
}
